import axios from 'axios'
import api from './api'
import Vue from 'vue'
import { Base64 } from 'js-base64'
import { Toast } from 'vant'
import qs from 'qs'

Vue.use(Toast)

// Development uses the proxy in vue.config.js, production uses .env.production
const instance = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? '/api' : `${window.location.origin}/api`,
    timeout: 5000,
    withCredentials: true,
})

instance.interceptors.request.use(
    config => {
        if (config.method === 'post') {
            config.headers = {
                'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
            }
        }

        if (localStorage.getItem('token')) {
            config.headers = {
                ...config.headers,
                token: Base64.encode(localStorage.getItem('token')),
                lang: localStorage.getItem('lang') || 'en',
            }
        }

        return config
    },
    err => {
        console.error('request failed', err)
    }
)

instance.interceptors.response.use(
    res => {
        if (res.data.msg === '閴存潈閿欒') {
            // localStorage.clear();
        }
        return res
    },
    err => Promise.reject(err)
)

async function http(option = {}) {
    let result = null
    if (option.method === 'get' || option.method === 'delete') {
        await instance[option.method](api[option.url], { params: option.data })
            .then(res => {
                result = res.data
                result.data = JSON.parse(Base64.decode(result.data))
            })
            .catch(err => {
                result = err
            })
    } else if (option.method === 'post' || option.method === 'put') {
        await instance[option.method](api[option.url], qs.stringify(option.data))
            .then(res => {
                result = res.data
                result.data = JSON.parse(Base64.decode(result.data))
            })
            .catch(err => {
                result = err
            })
    }
    return result
}

export default http
